<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-explore-three></app-breadcrumb-explore-three>
    <app-explore-four-section></app-explore-four-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
